import { render, staticRenderFns } from "./PanelTypeSelector.vue?vue&type=template&id=140020b2&scoped=true"
import script from "./PanelTypeSelector.vue?vue&type=script&lang=js"
export * from "./PanelTypeSelector.vue?vue&type=script&lang=js"
import style0 from "./PanelTypeSelector.vue?vue&type=style&index=0&id=140020b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140020b2",
  null
  
)

export default component.exports